import type { ConsentStatusItem } from '@/api/consents/consentsApi.types';
import { CONSENT_DECISION } from '@/constants/consents';

export function isOnboardingComplete(consents: ConsentStatusItem[]): boolean {
  return consents.every(function agreedAndCurrent(item) {
    if (item.needsReacceptance === true) {
      return false;
    }
    if (item.isRequired === false) {
      return true;
    }
    return item.decision === CONSENT_DECISION.agreed;
  });
}

export function listDeclinedRequiredConsents(consents: ConsentStatusItem[]): ConsentStatusItem[] {
  return consents.filter(function declinedAndRequired(item) {
    if (item.isRequired === false) {
      return false;
    }
    return item.decision === CONSENT_DECISION.declined || item.decision === CONSENT_DECISION.withdrawn;
  });
}
